import onLogout from './handlers/onLogout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import onVisitPage from './handlers/onVisitPage';
import onShowToast from './handlers/onShowToast';
import onReditectTo from './handlers/onReditectTo';
import onNetworkError from './handlers/onNetworkError';
import onLoginSuccess from './handlers/onLoginSuccess';
import onTokenNotFound from './handlers/onTokenNotFound';
import onChangeLanguage from './handlers/onChangeLanguage';
import { buildEventBusEffect, EventBusFactory } from '@utilities/event-bus';

const eventBus = EventBusFactory.resolve('global');
const useBusEffectOn = buildEventBusEffect(eventBus);

export default function GlobalEventListener() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useBusEffectOn('ERR_NETWORK', onNetworkError());
  useBusEffectOn('login-success', onLoginSuccess());
  useBusEffectOn('token-not-found', onTokenNotFound(t));
  useBusEffectOn('visit-page', onVisitPage({ navigate }));
  useBusEffectOn('do-logout', onLogout(navigate, eventBus.dispatch));
  useBusEffectOn('show-toast', onShowToast({ translator: t }));
  useBusEffectOn('change-language', onChangeLanguage({ i18n }));
  useBusEffectOn('redirect-to', onReditectTo(navigate, eventBus.dispatch));

  if (process.env.NODE_ENV === 'development') window.dispatch = (event, payload) => eventBus.dispatch(event, payload);

  return null;
}
